import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import { NgForm } from '@angular/forms';
import { Plugins, KeyboardInfo, Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import { EmployeeService } from '../core/services/employee.service';
import { Employee } from '../core/models/employee';
import { MemberService } from '../core/services/member.service';
import { Member } from '../core/models/member';
import { OnboardingService } from '../core/services/onboarding.service';
import { ToastController } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/auth';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Device_ID } from 'src/app/core/models/device_id'
import * as firebase from 'firebase';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  providers: [AndroidPermissions],
})
export class LoginPage implements OnInit {
  loginObj = { email: '', password: '' };
  submitted = false;
  showAppleSignIn = false;
  errorMessage = ''
  showProgress = false;
  signInResult: any;
  isEmployee = false;
  isMember = false;
  constructor(public authService: AuthService,
    private router: Router,
    private firebaseAuth: AngularFireAuth,
    private toastController: ToastController,
    private roleService: OnboardingService,
    private memberService: MemberService,
    private androidPermissions: AndroidPermissions
  ) {
  }
  async ngOnInit() {
    const { Device } = Plugins;
    let device = await Device.getInfo();
    this.showAppleSignIn = device.platform === 'ios';
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
      result => console.log('Has permission?', result.hasPermission),
      err => this.androidPermissions.requestPermissions(
        [
          this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE,
          this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
        ]
      )
    );
  }
  login(form: NgForm) {
    this.submitted = true;
    this.errorMessage = ''
    if (form.valid) {
      let Keyboard;
      if (Capacitor.platform !== "web") {
        Keyboard = Plugins.Keyboard;
        Keyboard.hide();
      }
      this.showProgress = true;
      const username = this.loginObj.email.replace(/^\s+|\s+$/g, '');
      const password = this.loginObj.password;
      this.authService.login(username, password)
        .then((res: firebase.auth.UserCredential) => {
          console.log('login', res.user)
          // debugger;
          this.signInResult = res;
          // this.roleService.fetchRole(res.user)
          this.loginObj.email = '';
          this.loginObj.password = '';
          this.showProgress = false;
          this.addDeviceInfo();
          // this.router.navigate(['/'])
        }, err => {
          this.presentToast("The username/password is invalid");
          this.showProgress = false;

          console.log(err.message);
        })
      this.submitted = false;
    }
  }

  async addDeviceInfo() {
    const { Device } = Plugins;
    const info = await Device.getInfo();
    const deviceInfo: Device_ID = {
      user_id: this.firebaseAuth.auth.currentUser.uid,
      uuid: info.uuid,
      type: info.platform,
      signature: JSON.stringify(info),
      created_date: firebase.firestore.Timestamp.now(),
    };
    this.memberService.deviceInfoCreate(deviceInfo, info.uuid).then(() => {
      console.log("Device info added!");
    });
  }

  async presentToast(err: string) {
    const toast = await this.toastController.create({
      message: err,
      duration: 2000
    });
    toast.present();
  }

  goToSignup() {
    this.firebaseAuth.auth.signOut()
      .then(() => {
        this.router.navigate(['/signup']);
      })
  }
  googleLogin() {
    this.authService.doGoogleLogin().then(res => {
      this.addDeviceInfo();
    })
  }
  fbLogin() {
    this.authService.doFacebookLogin();
  }
  twitterlogin() {
    // this.authService.doTwitterLogin();
  }
  // only for ios
  appleLogin() {
    this.authService.doAppleLogin().then(res => {
      this.addDeviceInfo();
    })
  }
}